export class FacebookAuth {
  appId: string;
  appVersion: string;

  constructor(appId: string, appVersion: string) {
    this.appId = appId;
    this.appVersion = appVersion;
  }

  createScriptTag() {
    const script = document.createElement('script');
    script.id = FacebookAuth.scriptId;
    script.src = FacebookAuth.scriptSrc;
    script.defer = true;
    script.async = true;
    script.onload = () => {
      const appId = this.appId;
      const appVersion = this.appVersion;

      (window as any).fbAsyncInit = function () {
        FB.init({
          appId,
          cookie: true,
          xfbml: true,
          version: appVersion,
        });
      };
    };
    return script;
  }

  static userLogin(loginCallback: (authResponse: any) => void) {
    if (!FB) {
      throw new Error('Error: facebook script is not installed properly');
    }
    FB.login(
      (response: fb.StatusResponse) => {
        loginCallback(response.authResponse);
      },
      { scope: 'email' }
    );
  }

  static get scriptSrc() {
    return 'https://connect.facebook.net/en_US/sdk.js';
  }

  static get scriptId() {
    return 'facebook-login-sdk';
  }
}
